import type { ReactNode } from 'react';
import React from 'react';

import { Footer } from 'client-site-chrome-ui/components/organisms/Footer/Footer';
import { Header } from 'client-site-chrome-ui/components/organisms/Header/Header';
import { Navigation } from 'client-site-chrome-ui/components/organisms/Navigation/Navigation';
import { SEOLinks } from 'client-site-chrome-ui/components/organisms/SEOLinks/SEOLinks';
import type { SiteChromeContent } from 'client-site-chrome-ui/content/fetchSiteChromeContent';
import { SiteChromeDynamicContextProvider } from 'client-site-chrome-ui/context/SiteChromeDynamicContext/SiteChromeDynamicContextProvider';
import { createSiteChromeStaticContextProvider } from 'client-site-chrome-ui/context/SiteChromeStaticContext/createSiteChromeStaticContextProvider';
import type { SiteChromeStaticContextValue } from 'client-site-chrome-ui/context/SiteChromeStaticContext/types';

export interface SiteChromeLayoutProps extends SiteChromeStaticContextValue {
  children?: ReactNode;
  enableCurator?: boolean;
  siteChromeContent?: SiteChromeContent;
  stickyTopBanner?: boolean;
}

export const createSiteChromeLayout = (appSelector?: string) => {
  const SiteChromeStaticContextProvider = createSiteChromeStaticContextProvider(appSelector);

  return ({
    children,
    enableCurator,
    siteChromeContent,
    stickyTopBanner = false,
    ...staticContext
  }: SiteChromeLayoutProps) => {
    const { navContent, topBannerMessages } = siteChromeContent || {};

    return (
      <>
        {navContent && <SEOLinks content={navContent} />}
        <SiteChromeStaticContextProvider {...staticContext}>
          <SiteChromeDynamicContextProvider>
            <Header
              enableCurator={enableCurator}
              stickyTopBanner={stickyTopBanner}
              topBannerMessages={topBannerMessages || []}
            />
            {navContent && <Navigation content={navContent} />}
            <main role="main">{children}</main>
            <Footer />
          </SiteChromeDynamicContextProvider>
        </SiteChromeStaticContextProvider>
      </>
    );
  };
};
